/**
 * This replaces all new lines with a space.
 * NOTE: When this the pasted text is formatted, it will prevent the user
 * from being able to undo with `Ctrl + Z` or `Cmd + Z`.
 */
export const removeNewlines = (value: string) => value.replace(/(\r\n|\n|\r)/gm, ' ');
